import http from "../../../services/http";
import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";

// 掛金納付対象職員届の提出確認参照API
import {
  IAPI_PRE010_Request,
  IAPI_PRE010_Response,
} from "../../../type/apiType";

// 掛金納付対象職員届の提出確認参照API
const httpAPI_PRE010 = async (
  param: IAPI_PRE010_Request
): Promise<IAPI_PRE010_Response> => {
  let res = await http.post(ApiUrl.API_PRE010, {
    ...param,
  });
  return res.data;
};

export { httpAPI_PRE010 };
